
var LookupData = require('../../utils/state/actions/lookup/lookupData.js');
var OrgData = require('../../utils/state/actions/org/orgData.js');
var CreditCardTerminal = require('./actions/creditCardTerminal/creditCardTerminal.js');

const AccountsData = require('../../utils/state/actions/accounts/accountsData');

module.exports.createState = function()
{
    return {
                internetConnectionSuspended: false,
                internetConnectionDisconnected: false,

                applicationInitialized: false,
                applicationInitializationDateTime: null,
                passport: null,
                passportExpired: false,
                staffLoginData: null,
                
                creditCardTerminal: new CreditCardTerminal(),


                alertDialogue: null,
                promptDialogue: null,
                settingsChangedTimeStamp: null,
                loginDialogue: null,
                navigationDialogue: null,
                navigationPage: null,
                onScreenKeyboard: null,
                tillStatus: "open",
                isLoadingRunningLate: false,
                screenSaver: false,


                lookupData: new LookupData(),
                orgData: new OrgData(),
                accountsData: new AccountsData(),
                staffs: [],
                menus: [],
                snoozes: [],
                discountOffers: [],
                paymentTypes: [],
                todaySales: [],
                todaySalesKdsStatus: new Map(),
                todaysSalesUpdatedDateTime: null,
                cliLogs: [],
                printingTemplates: [],
                saleContext: null,
                orderNumber: null,

                cashFloatPayload: null,
                currentStorefrontId: null,

                userNotificationLastAddedDateTime: null,

                layoutCurrentPageIndex: 0,
                
           }
}
